/**
 * Watches login and syncs buffered pre-login property_viewed behavior events.
 * Isolated from Portal property-view sync (engagement) — this path posts to
 * /api/behavior-events only.
 */
export default defineNuxtPlugin(nuxtApp => {
	nuxtApp.hook('app:suspense:resolve', () => {
		const { loggedIn } = useUserSession();
		watch(loggedIn, (isLoggedIn, wasLoggedIn) => {
			if (!isLoggedIn || wasLoggedIn) return;
			void import('~/composables/useBehaviorEventTracking')
				.then(m =>
					nuxtApp.runWithContext(() => {
						m.useBehaviorEventTracking().syncOfflineBehaviorViews();
					})
				)
				.catch(() => {});
		});
	});
});
